/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit State/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Encoding from './Encoding/index'
import Error from './Error/index'
import Initial from './Initial/index'
import No from './No/index'
import Paused from './Paused/index'
import React from 'react'
import Recording from './Recording/index'
import Starting from './Starting/index'



/** @type {import('Simple/types.js').View} */
export default function State({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/Tabs/AiRecorder/Content/State"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let recorderStateValueData = fromData.useDataFormat({ viewPath,
context: 'recorder',
path: 'state',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: recorderStateValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Initial'}>
<Initial
  viewPath={`${viewPath}/Initial`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Starting'}>
<Starting
  viewPath={`${viewPath}/Starting`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Recording'}>
<Recording
  viewPath={`${viewPath}/Recording`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Paused'}>
<Paused
  viewPath={`${viewPath}/Paused`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Encoding'}>
<Encoding
  viewPath={`${viewPath}/Encoding`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Error'}>
<Error
  viewPath={`${viewPath}/Error`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}